// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yN","title":"yO","notSelected":"yP","duration":"yQ","image":"yR","infoWrapper":"yS","description":"yT"};